// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._syaz1wmz{color:var(--ds-text-subtlest,#6b778c)}", ""]);
// Exports
module.exports = exports;
